import React from 'react';
import {NotificationManager} from 'react-notifications';
import {Col, Container, Form, Row, Button} from "react-bootstrap";
import {withTranslation} from "react-i18next";

// React Components
import Header from '../../../components/Header/Header';
import Input from '../../../components/Input/Input';
import InputSelect from '../../../components/InputSelect/InputSelect';
import InputRadio from '../../../components/InputRadio/InputRadio';
import InputTextArea from '../../../components/InputTextArea/InputTextArea';
import BulletHeader from "../../../components/BulletHeader/BulletHeader";

// Icons
import emoticon from "../../../assets/images/wink.svg";

// CSS Files
import './styles.css';

class PadelLevel extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            playing_time: '',
            had_previous_classes: false,
            previous_classes_location: '',
            previous_classes_teacher: '',
            previous_classes_schedule: '',
            clubs: '',
            has_enrolled_fed_tournaments: false,
            federation_ranking: '',
            has_experience: false,
            has_friends_playing: false,
            friends: [],
            comments: ''
        }
    }

    render() {
        const { t } = this.props;

        const questionTitles = {
            1: t("registration_page.experience"),
            2: t("registration_page.lessons"),
            2.1: t("registration_page.lessons_where"),
            2.2: t("registration_page.lessons_coach"),
            2.3: t("registration_page.lessons_when"),
            3: t("registration_page.clubs"),
            4: t("registration_page.federative_tournaments"),
            4.1: t("registration_page.ranking"),
            5: t("registration_page.experience_rackets"),
            6: t("registration_page.friends"),
            7: t("registration_page.other_info")
        }

        return (
            <div>
                <Header headerBarTitle={t("registration_page.header")} showHeaderExtras showBackButton />

                <Container className={"desktop"}>
                    <Row>
                        <Col className={"pb-3"} xs={12} sm={12}>
                            <BulletHeader text={t("registration_page.padel_level")}/>
                            <p>{t("registration_page.padel_level_note")}</p>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} sm={12}>
                            <InputSelect text={questionTitles["1"]}>
                                <Form.Control as="select" onChange={this.handleChange} defaultValue={"DEFAULT"} name="playing_time" className="input-background">
                                    <option value="DEFAULT" disabled>{t("common.form.options.choose_an_option")}</option>
                                    <option value="more_than_5_years">{t("registration_page.experience_more_5y")}</option>
                                    <option value="1-5_years">{t("registration_page.experience_1_5y")}</option>
                                    <option value="6months_1year">{t("registration_page.experience_6m_1y")}</option>
                                    <option value="less_than_6_months">{t("registration_page.experience_less_6m")}</option>
                                </Form.Control>
                            </InputSelect>
                            <InputRadio handleChange={this.handleChange} name="had_previous_classes" text={questionTitles["2"]} firstRadioText={t("common.yes")} secondRadioText={t("common.no")} checked={this.state.had_previous_classes}/>
                            {this.state.had_previous_classes && <div className="sub-input-spacing mb-4">
                                <Input handleChange={this.handleChange} name="previous_classes_location" id="location" inputType="text" text={questionTitles["2.1"]}/>
                                <Input handleChange={this.handleChange} name="previous_classes_teacher" id="teacher" inputType="text" text={questionTitles["2.2"]} />
                                <Input handleChange={this.handleChange} name="previous_classes_schedule" id="when" inputType="text" text={questionTitles["2.3"]} />
                            </div>}
                            <Input handleChange={this.handleChange} name="clubs" id="playedClubs" inputType="text" text={questionTitles["3"]} />

                            <InputRadio handleChange={this.handleChange} name="has_enrolled_fed_tournaments" text={questionTitles["4"]} firstRadioText={t("common.yes")} secondRadioText={t("common.no")} checked={this.state.has_enrolled_fed_tournaments}/>
                            {this.state.has_enrolled_fed_tournaments && <div className="sub-input-spacing">
                                <Input handleChange={this.handleChange} name="federation_ranking" id="fedRanking" inputType="number" text={questionTitles["4.1"]} />
                            </div>}
                            <InputRadio handleChange={this.handleChange} name="has_experience" text={questionTitles["5"]} firstRadioText={t("common.yes")} secondRadioText={t("common.no")} checked={this.state.has_experience}/>

                            <div style={{marginBottom: 15}}>
                                <InputRadio handleChange={this.handleChange} name="has_friends_playing" text={questionTitles["6"]} firstRadioText={t("common.yes")} secondRadioText={t("common.no")} checked={this.state.has_friends_playing}/>
                            </div>

                        </Col>
                        <Col xs={12}>
                            {this.state.has_friends_playing &&
                            <Row className="div-background-friends pt-3 pb-3 mb-3">
                                <Col xs={12}>
                                    {this.state.friends.map((item, key) => {
                                        return (
                                            <Row className={"mb-4"} key={key.toString()}>
                                                <Col xs={6}>
                                                    <h3><b>{t("registration_page.friend", {number: key + 1})}</b></h3>
                                                </Col>
                                                <Col xs={6}>
                                                    <Button onClick={() => this.removeAvailability(key)} className={"w-100"} variant="secondary">{t("registration_page.remove")}</Button>
                                                </Col>

                                                <Col className="div-input-friend">
                                                    <Input id="friendName" inputText={this.state.friends[key].name} handleChange={(e) => this.handleChangeFriendsName(e, key)} inputType="text" text={t("common.form.labels.name")} />
                                                    <Input id="friendPhoneNumber" inputText={this.state.friends[key].phone_number} handleChange={(e)=> this.handleChangeFriendsPhoneNumber(e, key)} inputType="number" text={t("common.form.labels.phone_number")} />

                                                    <p className="p-text-style">{t("registration_page.leveled_matches")}</p>

                                                    <Form>
                                                        <Form.Group controlId="formBasicRangeCustom">
                                                            <Row>
                                                                <Col xs={4}>{t("registration_page.we_win")}</Col>
                                                                <Col xs={4} className={"text-center"}>{t("registration_page.balanced")}</Col>
                                                                <Col xs={4} className={"text-right"}>{t("registration_page.they_win")}</Col>
                                                            </Row>
                                                            <Form.Control onChange={(e) => this.handleChangeFriendsRating(e, key)} value={this.state.friends[key].rating} type="range" custom min={0} max={2} step={1} />
                                                        </Form.Group>
                                                    </Form>


                                                </Col>
                                            </Row>
                                        )
                                    })}

                                    <Col xs={12} sm={{span: 6, offset: 3}} className={"pt-3"}>
                                        <Button onClick={() => this.addFriend()} className={"mt-0 mb-4 w-100 "} variant="secondary">{t("registration_page.add_friend")}</Button>
                                    </Col>
                                </Col>

                            </Row>}
                        </Col>
                        <Col xs={12}>
                            <InputTextArea handleChange={this.handleChange} name="comments" id="comments" rows="3" text={questionTitles["7"]}/>
                            <p className="p-text-style">{t("registration_page.end_note")}<span className="emoticon-text-align"><img src={emoticon} alt="wink-emoticon"/></span></p>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} sm={{span: 5, offset: 7}}>
                            <Button onClick={() => this.submit({padel_level: this.state})} className={"mt-4 mb-4 w-100"} variant="primary">{t("registration_page.next")}</Button>
                        </Col>
                    </Row>
                </Container>

            </div>
        )
    }
    
    removeAvailability = (index) => {
        const friends = this.state.friends
        friends.splice(index, 1)

        this.setState({
            friends: friends,
        });
    }

    handleChangeFriendsName = (event, key) => {
        let friends = this.state.friends
        friends[key].name = event.target.value
        this.setState({friends})
    }

    handleChangeFriendsPhoneNumber = (event, key) => {
        let friends = this.state.friends
        friends[key].phone_number = event.target.value
        this.setState({friends})
    }

    handleChangeFriendsRating = (event, key) => {
        let friends = this.state.friends
        friends[key].rating = event.target.value
        this.setState({friends})
    }

    addFriend = () => {
        let friends = this.state.friends

        let friend = {
            name: '',
            phone_number: '',
            rating: '1'
        }

        friends.push(friend)

        this.setState(friends) 

    }

    handleChange = (event) => {
        let value = event.target.value
        this.setState({
            [event.target.name]: value
        });
    }

    submit = (data) => {
        if(this.verifyData()){
            this.props.onSubmit(data)
        }
    }

    verifyData = () => {
        const { t } = this.props;
        let isAcceptable = true

        if(this.state.playing_time === '') {
            isAcceptable = false
            NotificationManager.error(t("registration_page.errors.padel_level.experience_mandatory"), t("common.error"), 4000)
            return isAcceptable
        }

        if(this.state.had_previous_classes){
            if(this.state.previous_classes_location === ''){
                isAcceptable = false
                NotificationManager.error(t("registration_page.errors.padel_level.classes_mandatory"), t("common.error"), 4000)
                return isAcceptable
            }

            if(this.state.previous_classes_teacher === ''){
                isAcceptable = false
                NotificationManager.error(t("registration_page.errors.padel_level.classes_mandatory"), t("common.error"), 4000)
                return isAcceptable
            }

            if(this.state.previous_classes_schedule === ''){
                isAcceptable = false
                NotificationManager.error(t("registration_page.errors.padel_level.classes_mandatory"), t("common.error"), 4000)
                return isAcceptable
            }
        }

        if(this.state.clubs === ''){
            isAcceptable = false
            NotificationManager.error(t("registration_page.errors.padel_level.clubs_mandatory"), t("common.error"), 4000)
            return isAcceptable
        }

        if(this.state.has_enrolled_fed_tournaments){
            if(this.state.federation_ranking === ''){
                isAcceptable = false
                NotificationManager.error(t("registration_page.errors.padel_level.ranking_mandatory"), t("common.error"), 4000)
                return isAcceptable
            }
        }

        if(this.state.has_friends_playing){
            if(this.state.friends.length >= 1){
                this.state.friends.forEach((friend, i) => {
                    let friendNumber = i + 1
                    if(friend.name === ''){
                        isAcceptable = false
                        NotificationManager.error(t("registration_page.errors.padel_level.friend_mandatory"), t("common.error"), 4000)
                        return isAcceptable
                    }

                    if(friend.phone_number === ''){
                        isAcceptable = false
                        NotificationManager.error(t("registration_page.errors.padel_level.friend_mandatory"), t("common.error"), 4000)
                        return isAcceptable
                    }

                    if(friend.rating === ''){
                        isAcceptable = false
                        NotificationManager.error(t("registration_page.errors.padel_level.friend_mandatory"), t("common.error"), 4000)
                        return isAcceptable
                    }
                })
            }else{
                isAcceptable = false
                NotificationManager.error(t("registration_page.errors.padel_level.no_friends_added"), t("common.error"), 4000)
                return isAcceptable
            }
        }
        return isAcceptable
    }

}

export default withTranslation()(PadelLevel);